import styled from 'styled-components';

import Image from '@stencil/image';
import {HiddenElement} from '../../../CommonStyleUtils/dwebCommon.styles';

import LocationInfoIcon from '../../../../../stories/Icons/LocationInfoIcon';

const HappyLocationNewIcon = styled(Image)(
  props => `
    margin="0 0.5rem 0 0";
    width: 2rem;
    height: 2rem;
    margin-left: 0.5rem;
  `,
);

const HotelAddressStyled = styled.address(
  props => `
  font-style: inherit;
  width: max-content;
`,
);

const HotelAddressTextDiv = styled.div(
  props => `
  color: #4A4A4A;
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  `,
);

const AddressTextLeftSpan = styled.span(
  props => `
   display: flex;
   align-items: center;
   width: auto;
  `,
);

const HotelCompleteAddressSpan = styled.span(
  props => `
  font-size: ${props.theme.font.custom(14)};
  color:#46484d;
  font-weight:medium;
  display: inline-block;
  text-overflow: ellipsis;
  overflow: hidden;
  width: 550px;
  white-space: pre;
  -webkit-line-clamp: 1;
`,
);

const ViewMapLink = styled.span(
  props => `
  color:${props.theme.colors.goBrandBlue.base};
  font-weight: 600;
`,
);

const PersuationAddress = styled.span(
  props => `
  padding-left: 7px;
  -webkit-box-orient: vertical;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  overflow: hidden;
`,
);

const PersuationAddressOuterSpan = styled.span(
  props => `
  display: flex;
  align-items: center;
  margin-right:${props.theme.spacing.base};
  margin-left: 5px;
  width: 70%;
`,
);

const iconUrl = 'https://gos3.ibcdn.com/idea-1626422541.png';

function HotelAddressText({
  address,
  locationPersuasion,
  pinCode,
  primaryArea,
  locName,
  hotelCountry,
}) {
  if (!address) {
    return null;
  }

  const locPers = locationPersuasion && locationPersuasion.length > 1 && locationPersuasion[1];
  return (
    <HotelAddressTextDiv>
      <AddressTextLeftSpan>
        <LocationInfoIcon margin="0.5rem 0 0 0" width="2.5rem" />
        <HotelAddressStyled itemScope itemProp="address" itemType="http://schema.org/PostalAddress">
          {primaryArea === locName ? primaryArea : `${primaryArea}, ${locName}`}
          {pinCode && <HiddenElement itemProp="postalCode">{pinCode}</HiddenElement>}
          {primaryArea && <HiddenElement itemProp="addressLocality">{primaryArea}</HiddenElement>}
          {locName && <HiddenElement itemProp="addressRegion">{locName}</HiddenElement>}
          {hotelCountry && <HiddenElement itemProp="addressCountry">{hotelCountry}</HiddenElement>}
        </HotelAddressStyled>
      </AddressTextLeftSpan>
      {locPers && (
        <PersuationAddressOuterSpan>
          |
          <HappyLocationNewIcon margin="0 0.5rem 0 0" src={iconUrl} />
          <PersuationAddress>{locPers}</PersuationAddress>
        </PersuationAddressOuterSpan>
      )}
    </HotelAddressTextDiv>
  );
}

export default HotelAddressText;
